import React from "react";
import { useGoogleLogout, useGoogleLogin } from "react-google-login";
import { imageURL } from "../../../constants/constants";
// refresh token
import { refreshTokenSetup } from "../../../utils/helpers";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const onGoogleLogoutSuccess = (res) => {};

const onGooleLogoutFailure = (res) => {};

const GoogleLoginButton = (props) => {
  const onSuccess = (res) => {
    const { email } = res.profileObj;
    if (email) {
      props.onFinish(res.profileObj);
    }
    refreshTokenSetup(res);
  };

  const { signOut } = useGoogleLogout({
    clientId,
    onGoogleLogoutSuccess,
    onGooleLogoutFailure,
  });

  const onFailure = (res) => {
    signOut();
    props.onFinishFailed(res);
  };
  const { signIn } = useGoogleLogin({ clientId, onSuccess, onFailure });

  return (
    <div>
      <div className="btn-wrper mt-2">
        <button
          onClick={(e) => {
            e.preventDefault();
            signIn();
          }}
          className="btn btn-primary bg-2"
        >
          {props.btnText}
        </button>
        <span className="btn-icon">
          <img
            src={`${imageURL}google-icon.png`}
            className="img-fluid"
            alt=""
          />{" "}
        </span>
      </div>
    </div>
  );
};

export default GoogleLoginButton;
